/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import TaskInfoBlockAsOwner from '../../../../../components/Tasks/TaskView/TaskInfoBlockAsOwner';

import TaskDescBlock from '../../../../../components/Tasks/_common/TaskDescBlock';
import CommentsIn from '../../../../../components/Comment/ReducerWrappers/CommentsIn';
import TasksExecsListByTask from '../../../../../components/Tasks/TasksExecsLists/TasksExecsListByTask';

const routes = props => [
  {
    path: `/my-tasks/view/${props.task.id}`,
    exact: true,
    component: () => <Redirect to={`/my-tasks/view/${props.task.id}/desc`} />
  },
  {
    path: `/my-tasks/view/${props.task.id}/desc`,
    component: TaskDescBlock
  },
  {
    path: `/my-tasks/view/${props.task.id}/reviews`,
    exact: true,
    component: CommentsIn,
    props: {
      modelClass: 'Tasks',
      modelId: props.task.id,
      commentsOwnerId: props.task.ownerId,
      commentsInStat: props.task.taskCommentsStat
    }
  },
  {
    path: `/my-tasks/view/${props.task.id}/reviews/likes`,
    component: CommentsIn,
    props: {
      modelClass: 'Tasks',
      modelId: props.task.id,
      queryParamsStatic: { like: 1 },
      commentsOwnerId: props.task.ownerId,
      commentsInStat: props.task.taskCommentsStat
    }
  },
  {
    path: `/my-tasks/view/${props.task.id}/reviews/dislikes`,
    component: CommentsIn,
    props: {
      modelClass: 'Tasks',
      modelId: props.task.id,
      queryParamsStatic: { like: -1 },
      commentsOwnerId: props.task.ownerId,
      commentsInStat: props.task.taskCommentsStat
    }
  },
  {
    path: `/my-tasks/view/${props.task.id}/reviews/neutral`,
    component: CommentsIn,
    props: {
      modelClass: 'Tasks',
      modelId: props.task.id,
      queryParamsStatic: { like: 0 },
      commentsOwnerId: props.task.ownerId,
      commentsInStat: props.task.taskCommentsStat
    }
  },
  {
    path: `/my-tasks/view/${props.task.id}/executions`,
    exact: true,
    component: TasksExecsListByTask,
    props: {
      taskId: props.task.id
    }
  },
  {
    path: `/my-tasks/view/${props.task.id}/executions/:execStatus`,
    component: TasksExecsListByTask,
    props: {
      taskId: props.task.id
    }
  }
];

const RouteWithSubRoutes = (route, props) => (
  <Route
    path={route.path}
    exact={route.exact || false}
    render={() => (
      <route.component {...props} {...route.props} routes={route.routes} />
    )}
  />
);

// eslint-disable-next-line react/prefer-stateless-function
class TaskViewAsOwner extends Component {
  render() {
    return (
      <React.Fragment>
        <TaskInfoBlockAsOwner task={this.props.task} />
        <Switch>
          {routes(this.props).map(route => (
            <RouteWithSubRoutes
              key={`route${route.path}`}
              {...route}
              props={{ ...this.props, ...route.props }}
            />
          ))}
        </Switch>
      </React.Fragment>
    );
  }
}

TaskViewAsOwner.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired
};

export default withRouter(TaskViewAsOwner);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/TaskViewAsOwner/TaskViewAsOwner.js